module.exports = __webpack_public_path__ + "static/media/DSC_0390.29970a89.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/events/DSC_0390.jpg
// module id = 599
// module chunks = 0